import "./SummaryCard.css";
import React from "react";
import PropTypes from "prop-types";
import Card, { CardContent } from "material-ui/Card";
import Typography from "material-ui/Typography";

function SummaryCard(props) {
  const {
    title,
    value,
    units,
    className,
    imageUrl,
    imageWidth,
    imageHeight
  } = props;
  const classNames = className !== undefined ? className : "";
  return (
    <Card className={`summary-card card ${classNames}`} elevation={0}>
      <CardContent>
        <Typography variant="title" align="center" color="primary">
          {title}
        </Typography>
        <div className="summary-image-container">
          {imageUrl && (
            <img
              src={imageUrl}
              alt=""
              style={{
                width: imageWidth ? imageWidth : "3rem",
                height: imageHeight ? imageHeight : "3rem"
              }}
              className="summary-image"
            />
          )}
        </div>
        <Typography className="value" variant="display1">
          {value}
        </Typography>
        <Typography align="center" className="units">
          {units}
        </Typography>
      </CardContent>
    </Card>
  );
}

SummaryCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  units: PropTypes.string,
  imageUrl: PropTypes.string,
  className: PropTypes.string
};

export default SummaryCard;



// WEBPACK FOOTER //
// ./src/components/SummaryCard/SummaryCard.js